import type { Bounds, Key } from '@thinkalpha/table-client';
import { createLegacyInstance } from 'src/api';
import { appConfig } from 'src/lib/config/appConfig';

const axios = createLegacyInstance();

export type Snapshot = {
    key: Key;
    bounds: Bounds;
    data: Record<string, unknown>[];
    rowsCount: number;
};

type NextGenSnapshotDescriptor = {
    field: string;
    description?: string;
    type: string;
};

type NextGenSnapshotResponse = {
    subscription_id: string;
    total_row_count: number;
    descriptors: NextGenSnapshotDescriptor[];
    rows: ({ row_id: number } & Record<string, unknown>)[];
    totals_descriptors?: NextGenSnapshotDescriptor[];
    totals?: Record<string, unknown>;
};

export const getSnapshot = async (
    useNgProxy: boolean,
    tableKey: Key,
    cookie?: string,
    firstRow?: number,
    windowSize?: number,
): Promise<Snapshot> => {
    const bounds = {
        firstRow: firstRow ?? 0,
        windowSize: windowSize === Infinity ? Math.pow(2, 15) : (windowSize ?? 50),
    };
    const resource = useNgProxy ? 'snapshot' : 'tables';
    const url = `/${resource}/${encodeURIComponent(tableKey.sym)}:${tableKey.ex}`;
    const config = {
        params: useNgProxy
            ? {
                  first_row: bounds.firstRow,
                  window_size: bounds.windowSize,
              }
            : {
                  firstRow: bounds.firstRow,
                  windowSize: bounds.windowSize,
              },
        headers: {
            ...(cookie ? { Authorization: 'Bearer ' + cookie } : {}),
        },
        baseURL: useNgProxy ? appConfig.httpNgTableProxy : appConfig.tableProxy,
    };

    if (useNgProxy) {
        const { data } = await axios.get<NextGenSnapshotResponse>(url, config);
        return {
            key: tableKey,
            bounds,
            data: data.rows,
            rowsCount: data.total_row_count,
        };
    }

    const { data } = await axios.get<Snapshot>(url, config);
    return data;
};
